import React from "react"

export interface FormLabelProps {}

const FormLabel: React.FC<FormLabelProps> = ({ children }) => {
  return <label className="mt-2 mb-1">{children}</label>
}

export default FormLabel
